<template>
  <td v-if="visible" :class="rootClasses" :data-label="label">
    <template v-if="$slots.default">
      <slot />
    </template>
    <template v-else>
      {{ fieldData }}
    </template>
  </td>
</template>

<script>
  import { defineComponent } from 'vue';
  import { getValueByPath } from '../../../utils/helpers.js';

  export default defineComponent({
    name: 'DTableColumn',
    props: {
      row: {
        type: Object,
        default: () => { },
      },
      alignment: {
        type: String,
        default: 'left',
      },
      label: String,
      customKey: [String, Number],
      field: String,
      meta: [String, Number, Boolean, Function, Object, Array, Symbol],
      width: [Number, String],
      numeric: Boolean,
      centered: Boolean,
      sortable: Boolean,
      visible: {
        type: Boolean,
        default: true,
      },
      customSort: Function,
      internal: Boolean, // Used internally by Table
    },

    data() {
      return {
        newKey: this.customKey || this.label,
      };
    },

    computed: {
      rootClasses() {
        return {
          [`text-${this.alignment}`]: !this.numeric && this.alignment,
          'text-right': this.numeric,
          'flex md:justify-center': this.alignment === 'center',
        };
      },

      fieldData() {
        if (this.field && this.row) {
          return getValueByPath(this.row, this.field);
        }
        return null;
      },
    },

    beforeMount() {
      this.addRefToTable();
    },

    beforeUpdate() {
      this.addRefToTable();
    },

    beforeUnmount() {
      const index = this.$parent.newColumns.map(
        (column) => column.newKey,
      ).indexOf(this.newKey);
      if (index >= 0) {
        this.$parent.newColumns.splice(index, 1);
      }
    },

    methods: {
      addRefToTable() {
        if (!this.$parent.$data._isTable) {
          this.$destroy();
          throw new Error('You should wrap DTableColumn on a DTable');
        }
        if (this.internal) return;
        // Since we're using scoped prop the columns gonna be multiplied,
        // this finds when to stop based on the newKey property.
        const repeated = this.$parent.newColumns.some(
          (column) => column.newKey === this.newKey,
        );
        !repeated && this.$parent.newColumns.push(this);
      },
    },
  });
</script>